var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/global"
  }, /*#__PURE__*/React.createElement("g", {
    id: "global"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.002 22.7492C6.07195 22.7492 1.25195 17.9292 1.25195 11.9992C1.25195 6.06921 6.07195 1.24921 12.002 1.24921C17.932 1.24921 22.752 6.06921 22.752 11.9992C22.752 17.9292 17.932 22.7492 12.002 22.7492ZM12.002 2.74921C6.90195 2.74921 2.75195 6.89921 2.75195 11.9992C2.75195 17.0992 6.90195 21.2492 12.002 21.2492C17.102 21.2492 21.252 17.0992 21.252 11.9992C21.252 6.89921 17.102 2.74921 12.002 2.74921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.99828 21.75H7.99828C7.58828 21.75 7.24828 21.41 7.24828 21C7.24828 20.59 7.56828 20.26 7.97828 20.25C6.40828 14.89 6.40828 9.11 7.97828 3.75C7.56828 3.74 7.24828 3.41 7.24828 3C7.24828 2.59 7.58828 2.25 7.99828 2.25H8.99828C9.23828 2.25 9.46828 2.37 9.60828 2.56C9.74828 2.76 9.78828 3.01 9.70828 3.24C7.82828 8.89 7.82828 15.11 9.70828 20.77C9.78828 21 9.74828 21.25 9.60828 21.45C9.46828 21.63 9.23828 21.75 8.99828 21.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9984 21.7491C14.9184 21.7491 14.8384 21.7391 14.7584 21.7091C14.3684 21.5791 14.1484 21.1491 14.2884 20.7591C16.1684 15.1091 16.1684 8.88911 14.2884 3.22911C14.1584 2.83911 14.3684 2.40911 14.7584 2.27911C15.1584 2.14911 15.5784 2.35911 15.7084 2.74911C17.6984 8.70911 17.6984 15.2691 15.7084 21.2191C15.6084 21.5491 15.3084 21.7491 14.9984 21.7491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 17.2008C9.21 17.2008 6.43 16.8108 3.75 16.0208C3.74 16.4208 3.41 16.7508 3 16.7508C2.59 16.7508 2.25 16.4108 2.25 16.0008V15.0008C2.25 14.7608 2.37 14.5308 2.56 14.3908C2.76 14.2508 3.01 14.2108 3.24 14.2908C8.89 16.1708 15.12 16.1708 20.77 14.2908C21 14.2108 21.25 14.2508 21.45 14.3908C21.65 14.5308 21.76 14.7608 21.76 15.0008V16.0008C21.76 16.4108 21.42 16.7508 21.01 16.7508C20.6 16.7508 20.27 16.4308 20.26 16.0208C17.57 16.8108 14.79 17.2008 12 17.2008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.9998 9.74938C20.9198 9.74938 20.8398 9.73938 20.7598 9.70938C15.1098 7.82938 8.87978 7.82938 3.22978 9.70938C2.82978 9.83938 2.40978 9.62937 2.27978 9.23937C2.15978 8.83937 2.36978 8.41938 2.75978 8.28938C8.71978 6.29938 15.2798 6.29938 21.2298 8.28938C21.6198 8.41938 21.8398 8.84937 21.6998 9.23937C21.6098 9.54937 21.3098 9.74938 20.9998 9.74938Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.63887c15fa30931715db5c3a8698bb00.svg";
export { ForwardRef as ReactComponent };